import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UiActions } from 'src/app/store/actions';
import { OnboardingProductsStore } from 'src/app/store/store';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { StepsNotClientTypes } from 'src/app/shared/enums';
import { LoadingService } from 'src/app/services/loading.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { DataNotClientService } from 'src/app/services/data-not-client.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contract-signing',
  templateUrl: './contract-signing.component.html',
  styleUrls: ['../../../global.scss', './contract-signing.component.scss']
})
export class ContractSigningComponent implements OnInit {
  closeResult = '';
  staticAssetsUrl = environment.staticScripts.staticAssets;
  public canShow = true;
  public tempPageView: string;

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private modalService: NgbModal,
    private dataNotClientService: DataNotClientService,
    public loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    document.getElementById('white-container').style.display = 'block';
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.setService();
  }

  setService() {
    const googleAnalytics = {
      is_joint_account: this.dataNotClientService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataNotClientService.getWorkActivityType() ? this.dataNotClientService.getWorkActivityType() : 'No informado',
        dateEntryWork: this.dataNotClientService.getDateEntryWork() ? this.dataNotClientService.getDateEntryWork() : 'No informado',
        companyName: this.dataNotClientService.getCompanyName() ? this.dataNotClientService.getCompanyName() : 'No informado',
        rucCompany: this.dataNotClientService.getRucCompany() ? this.dataNotClientService.getRucCompany() : 'No informado',
        profession: this.dataNotClientService.getProfession() ? this.dataNotClientService.getProfession() : 'No informado'
      },
      currency_account_type: this.dataNotClientService.getCurrencyType()
    };
    this.store.dispatch(TagPage({ text: 'manual-signing', extras: googleAnalytics }));
  }

  continue() {
    this.dataNotClientService.setCanCreateProduct(true);
    return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_CREATE_PRODUCT }));
  }

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'pe-modal-confirm',
        size: 'md'
      }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
      );
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
